"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.declineCodeEventLoad = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var declineCodeEventLoad = function (event) {
    var _a;
    var eventData = {
        action: analytics_layer_1.DeclineCodeEventNames.ProcessorErrorCode,
        event: 'processorerrorcode',
        eventInfo: 'processorerrorcode',
        processorerrorcode: {
            code: ((_a = event.eventData) === null || _a === void 0 ? void 0 : _a.apiResponseCode) || consts_1.NOT_AVAILABLE,
        }
    };
    return eventData;
};
exports.declineCodeEventLoad = declineCodeEventLoad;
